import React from "react";
import classNames from "classnames";
import "./DropdownUser.scss";
import Dropdown from "../Dropdown";
import Text from "../Text";
import ThemeSwitcher from "../ThemeSwitcher";
import SoundSwitcher from "../SoundSwitcher";
import { runForEach } from "../../utils/runForEach";

const DropdownUser = (props) => {
  const handleClick = (e) => {
    if (!!props.buttonClicked) {
      props.buttonClicked(e);
    }
  };
  let mainClassName = classNames({
    "user-dropdown": true,
  });

  let avatarClassName = classNames({
    "user-dropdown-icon": true,
  });

  let nameClassName = classNames({
    "user-dropdown-username": true,
  });

  let roleClassName = classNames({
    "user-dropdown-role": true,
  });

  let logoutClassName = classNames({
    "user-dropdown-logout": true,
  });

  let roles = "";
  if (!!props.roles) {
    runForEach(props.roles, (o) => (roles = `${roles}, ${o}`));
  }

  return (
    <Dropdown isExpanded={props.isExpanded} onRef={props.onRef}>
      <ul className={mainClassName}>
        <li className={avatarClassName}>{props.avatar}</li>
        <li className={nameClassName}>{props.username}</li>
        <li className={roleClassName}>{`(${props.roles})`}</li>
              <li >      <ThemeSwitcher /></li>
              <li >     <SoundSwitcher /></li>
        <li className={logoutClassName}>
          <a id="signout-button" href={props.signOutUrl} onClick={handleClick}>
            <Text value="Sign_Out" />
          </a>
        </li>
      </ul>
    </Dropdown>
  );
};

export default DropdownUser;
